import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PaymentFlowStatus from '../../components/PaymentFlowStatus';

const PaymentWidgetFail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const errorCode = searchParams.get('code');
  const errorMessage = searchParams.get('message');

  const errorDescriptions = {
    PAY_PROCESS_CANCELED: '결제를 취소했어요. 준비가 되면 다시 진행해주세요.',
    PAY_PROCESS_ABORTED: '결제가 중단됐어요. 잠시 후 다시 시도해주세요.',
    REJECT_CARD_COMPANY: '카드사에서 결제를 승인하지 않았어요. 한도를 확인하거나 다른 결제 수단을 사용해주세요.',
    INVALID_CARD_NUMBER: '카드 번호를 확인하지 못했어요. 번호를 다시 확인해주세요.',
    INVALID_CARD_EXPIRY: '카드 유효기간을 확인하지 못했어요. 유효기간을 다시 확인해주세요.',
    INVALID_CARD_INSTALLMENT: '선택한 할부 개월을 이용할 수 없어요. 다른 할부 개월을 선택해주세요.',
    EXCEED_MAX_AMOUNT: '결제 가능한 한도를 넘었어요. 한도를 확인하거나 다른 결제 수단을 사용해주세요.',
    EXCEED_MAX_DAILY_AMOUNT: '오늘 결제 가능한 한도를 넘었어요. 카드사에 문의하거나 다른 결제 수단을 사용해주세요.',
    EXCEED_MAX_MONTHLY_AMOUNT: '이번 달 결제 가능한 한도를 넘었어요. 카드사에 문의하거나 다른 결제 수단을 사용해주세요.',
    INVALID_PASSWORD: '결제 비밀번호를 확인하지 못했어요. 비밀번호를 다시 확인해주세요.',
    INCORRECT_BASIC_AUTH_FORMAT: '결제 인증 정보를 확인하지 못했어요. 잠시 후 다시 시도해주세요.',
    FDS_ERROR: '안전한 결제를 위해 승인이 보류됐어요. 다른 결제 수단을 이용하거나 카드사에 문의해주세요.',
  };

  const isCancelled = errorCode === 'PAY_PROCESS_CANCELED';
  const description = errorDescriptions[errorCode]
    || '결제를 승인하지 못했어요. 잠시 후 다시 시도하거나 다른 결제 수단을 사용해주세요.';
  const detailCode = [errorCode, errorMessage].filter(Boolean).join(' · ');

  return (
    <PaymentFlowStatus
      variant="error"
      title={isCancelled ? '결제를 취소했어요' : '결제를 완료하지 못했어요'}
      description={description}
      detailCode={detailCode}
      primaryAction={{
        label: '결제 다시 시도하기',
        onClick: () => navigate('/subscription/pro'),
      }}
      secondaryAction={{
        label: '홈으로 돌아가기',
        onClick: () => navigate('/home'),
      }}
      footer={(
        <p>
          같은 문제가 계속되면{' '}
          <a href="mailto:angel@plactical.com">고객센터로 알려주세요</a>
        </p>
      )}
    />
  );
};

export default PaymentWidgetFail; 